import { useParams } from "react-router-dom";
import useLoading from "../../../../shared/components/loading/useLoading";
import useAxios from "../../../../hooks/useAxios";
import { useEffect, useState } from "react";
import {
  API_PERMISSIONS,
  API_ROLES,
  API_USER_BY_ID,
  API_USER_ROLE,
  API_USER_ROLES_BY_ID,
} from "../../../../shared/lib/apiEndpointsResolver";
import { catchFunction } from "../../../../shared/lib/utils";
import BreadcrumbPanel from "../../../../shared/components/breadcrumb/BreadcrumbPanel";
import { USERS } from "../../../../shared/lib/routesResolver";
import UserInfoPanel from "./UserInfoPanel";
import UserInfoTabMenu from "./UserInfoTabMenu";
import useConfirmDialog from "../../../../shared/components/confirm-dialog/useConfirmDialog";
import useToastWrapper from "../../../../hooks/useToastWrapper";
import { useNavigate } from "react-router";

const UserDetail = () => {
  const { id } = useParams();
  const { setLoading } = useLoading();
  const axios = useAxios();
  const [user, setUser] = useState();
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [availableRoles, setAvailableRoles] = useState([]);
  const toast = useToastWrapper();
  const navigate = useNavigate();
  const deleteUserDialog = useConfirmDialog();
  const [userForDeletion, setUserForDeletion] = useState();
  const breadcrumbItems = [
    { title: "Usuarios", link: USERS },
    { title: user?.fullname },
  ];

  const findUser = () => {
    setLoading(true);
    axios
      .get(API_USER_BY_ID(id))
      .then((response) => setUser(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const findUserRoles = () => {
    axios
      .get(API_USER_ROLES_BY_ID(id))
      .then((response) => setRoles(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const findUserPermissions = () => {
    axios
      .get(`${API_PERMISSIONS}?user=${id}`)
      .then((response) => setPermissions(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const findAvailableRoles = () => {
    axios
      .get(API_ROLES)
      .then((response) => setAvailableRoles(response.data))
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const onUserDeletionClick = () => {
    deleteUserDialog.display(
      `Se eliminará del sistema al usuario ${user.username}. Los roles que tuviese asignados NO se eliminarán.`,
    );
  };

  const onUserDeletion = () => {
    setLoading(true);
    axios
      .delete(API_USER_BY_ID(id))
      .then((_) => {
        toast.success(
          `El usuario ${user.username} se ha eliminado correctamente`,
        );
        navigate(USERS);
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const onRoleAddition = (formValues) => {
    setLoading(true);
    axios
      .post(API_USER_ROLES_BY_ID(id), formValues)
      .then((response) => {
        toast.success(`Rol añadido al usuario ${response.data.username}`);
        findUserRoles();
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  const onRoleDeletion = (roleId) => {
    setLoading(true);
    axios
      .delete(API_USER_ROLE(id, roleId))
      .then((response) => {
        toast.success(`Rol eliminado del usuario ${response.data.username}`);
        findUserRoles();
      })
      .catch(catchFunction)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    findUser();
    findUserRoles();
    findUserPermissions();
    findAvailableRoles();
  }, [id]);

  return (
    <>
      {deleteUserDialog.renderDialog(onUserDeletion)}
      <div className="px-4 pb-4 sm:px-6">
        <BreadcrumbPanel items={breadcrumbItems} />
      </div>
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-row justify-between gap-x-4 px-4">
          <UserInfoPanel user={user} onDeletion={onUserDeletionClick} />
          <div></div>
        </div>
        <UserInfoTabMenu
          roles={{
            data: roles,
            available: availableRoles,
            onRoleAddition: onRoleAddition,
            onRoleDeletion: onRoleDeletion,
          }}
          permissions={permissions}
        />
      </div>
    </>
  );
};

export default UserDetail;
